// extracted by mini-css-extract-plugin
export default {"input":"sl0jR","input--indent":"L0Sce"};